'use client';

import { useQuery } from '@apollo/client';
import { ApolloNextAppProvider } from '@apollo/client-integration-nextjs';
import { PropsWithChildren } from 'react';

import { SuspenseContext } from '@nerdwallet/apollo/suspense-context';

import makeClient from './client';

const ApolloWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <ApolloNextAppProvider makeClient={makeClient}>
      <SuspenseContext.Provider
        value={{ maybeUseSuspenseQuery: useQuery as any }}
      >
        {children}
      </SuspenseContext.Provider>
    </ApolloNextAppProvider>
  );
};
export default ApolloWrapper;
